module.exports = __webpack_public_path__ + "static/img/dijkstra.624dd70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/dijkstra.png
// module id = 0U/1
// module chunks = 0